export default "__VITE_ASSET__o364bkLf__"